import { Configuration2D } from '../../../../models/configurators-2d/configuration2d';
import { BaseAppService } from '../../../../services/configurators-2d/base-app-service';
import { fabric } from 'fabric';
import { PreviewItem } from './preview-item';

export abstract class FabricPreviewItem<C extends Configuration2D, S extends BaseAppService<C>> extends PreviewItem<C, S> {
  // canvas
  canvas: fabric.Canvas;
  optionalCanvas: fabric.Canvas;

  // URL de base des images
  baseImgURL: string = undefined;

  async createOrUpdate(): Promise<void> {
    // récupération de la taille de la preview
    let parentWidth = document.getElementById('rendering').offsetWidth;
    let parentHeight = document.getElementById('rendering').offsetHeight;

    // initialisation du canvas
    return new Promise(resolve => {
      if (this.canvas) {
        this.canvas.setHeight(parentHeight);
        this.canvas.setWidth(parentWidth);

        resolve();
      } else {
        setTimeout(() => {
          this.canvas = new fabric.Canvas('preview-container', {
            height: parentHeight,
            width: parentWidth,
          });

          resolve();
        });
      }
    });
  }

  destroy(): void {
    this.canvas.dispose();
  }

  override async update(): Promise<void> {
    this.baseImgURL = this.service.apiUrl;
    await this.createOrUpdate();
  }
}
